
import Vue from "vue";
import {
  capitalizeFirstLetter,
  formatAgencyCode
} from "@/helpers/generalHelpers";
export default Vue.extend({
  name: "ViewChangeRequestInsurerDetails",
  props: {
    changeRequestData: {
      type: Object,
      required: true
    }
  },
  methods: {
    doFormatAgencyCode(): string {
      return formatAgencyCode(this.changeRequestData.policyInfo.agencyCode);
    },
    capitalizeFirstLetter
  },
  computed: {}
});
